import { Category, QueryCategoryPageOutput } from 'types/types';
import { CategoryPage } from './types';
import {
  GALLERY_SIZE,
  MAX_GALLERIES_PER_SHOP,
  LAYOUT_COLLECTION,
} from './constants';
import { prepProductListing } from 'components/_shared/widgets/product-listing/utils';

/**
 * similar to the asTitleCase function, only it handles hyphens and
 * replaces "And" with the ampersand symbol in category pages.
 */
export const categoryIdAsTitleCase = (id: string) =>
  id
    .toLowerCase()
    .replaceAll('-', ' ')
    .replaceAll('and', '&')
    .split(' ')
    .map(word => `${word.charAt(0).toUpperCase()}${word.substring(1)}`)
    .join(' ');

/**
 * NOTE: we pass the description directly to the layout as a page prop.
 * If we leave it on this category object it will be duplicated in our pages __NEXT_DATA__.
 * Considering how large these descriptions can get it's better to remove it.
 */
const removeDescription = ({ description: _, ...rest }: Category) => ({
  ...rest,
});

/**
 * Data/props preparation.
 */
export const categoryPageProps: (
  data: QueryCategoryPageOutput,
  categoryId: string,
  category?: Category
) => CategoryPage = ({ products, configs }, categoryId, category) => ({
  category: category ? removeDescription(category) : null,
  categoryId,
  items: prepProductListing({
    products,
    withShops: true,
    minItemsPerShop: 3,
    gallerySize: GALLERY_SIZE,
    maxGalleriesPerShop: MAX_GALLERIES_PER_SHOP,
    galleryLayouts: LAYOUT_COLLECTION,
    soldOutHeaders: configs?.soldOutOverlay,
  }),
  banner: category?.bannerImage || null,
});
